import Form from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { get, noop } from 'lodash';

import SaleRow from './SaleRow';
import { DroppableTable } from 'components/shared/DragDropTable';

type SalesTableProps = {
  form: Form;
  salesHistory: Record<string, any>[];
  block?: string;
  lot?: string;
  moveSale?: (result: DropResult) => void;
  removeSale?: (index: number) => void;
};

const SalesTable = observer(({ form, salesHistory, removeSale = noop, moveSale = noop }: SalesTableProps) => {
  const values = form.values();

  const address = get(values, 'property.address.street');
  const propertyIdentification = get(values, 'property.propertyIdentification');

  const salesHistoryRows = salesHistory.map((sale, index) => (
    <SaleRow
      id={`sale-row-${index}`}
      index={index}
      key={sale._id || `sale-row-${index}`}
      propertyIdentifier={propertyIdentification?.propertyIdentifier || 'N/A'}
      removeSale={removeSale}
      streetAddress={address}
      form={form}
    />
  ));

  const noSales = !salesHistory.length;
  return (
    <DragDropContext onDragEnd={moveSale}>
      <DroppableTable emptyTableMessage="No sales added" id="sale-history" isEmpty={noSales}>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Address</TableCell>
            <TableCell>{propertyIdentification?.propertyIdentifierType || 'Property Identifier'}</TableCell>
            <TableCell>Unique Sale ID</TableCell>
            <TableCell>Sale Date</TableCell>
            <TableCell>Sale Price</TableCell>
            <TableCell>Seller</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>{salesHistoryRows}</TableBody>
      </DroppableTable>
    </DragDropContext>
  );
});

export default SalesTable;
